<template>
  <section>
    <div class="wheel wow fadeInDown">
      <div class="bgs"></div>
      <img src="../../assets/image/banner_pohone.png" alt="img" class="banner_pohone lefts" />
      <img src="../../assets/image/banner_pohone2.png" alt="img" class="banner_pohone rights" />
      <img src="../../assets/image/banner_pohone3.png" alt="img" class="banner_pohone" />
      <div class="banner">
        <h2>健身教练考国职，就用教练王者！</h2>
        <span>10万健身教练在用的国职备考神器！</span>
        <a href="download.html">
          <div class="button--nina button" data-text="立即下载">
            <span>立</span>
            <span>即</span>
            <span>下</span>
            <span>载</span>
          </div>
        </a>
      </div>
    </div>
    <header :class="scrollTopNav?'header':'headers'">
      <div class="header_1200">
        <div class="df">
          <a href="index.html" class="logos">
            <h1>健身国职考试</h1>
          </a>
          <nav>
            <ul class="nav_list">
              <li>
                <a href="index.html">首页</a>
              </li>
              <li>
                <a href="search.html">搜题</a>
              </li>
              <li>
                <a href="videopage.html">实操视频</a>
              </li>
              <li>
                <a href="download.html">下载APP</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="search">
          <input type="text" placeholder="输入你要搜索的关键词" v-model.trim="titleKeyWords" @keyup.enter.native="onQuery" @change="onQuery" />
          <div class="ques active">
            <img src="../../assets/image/seach.png" alt="seach" />
          </div>
        </div>
      </div>
    </header>

    <section class="inner_1600">
      <div class="introduce">
        <div class="title">
          <h3>超多超全的备考功能</h3>
          <span>理论，实操，模拟，解析，视频，包你一条龙过国职！</span>
        </div>
        <div class="detailed wow zoomIn">
          <div class="keyboard">
            <div class="iconBox">
              <img src="../../assets/image/icon_alarmClock.png" alt="icon" />
              <span>理论模拟考试</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_promote.png" alt="icon" />
              <span>专项练习</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_order.png" alt="icon" />
              <span>顺序练习</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_wrongbook.png" alt="icon" />
              <span>错题集</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_promotion.png" alt="icon" />
              <span>晋级挑战</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_demonstration.png" alt="icon" />
              <span>实操动作演示</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_knowledge points.png" alt="icon" />
              <span>实操知识点练习</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_Aerobics.png" alt="icon" />
              <span>实操模拟考试</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_lecturer.png" alt="icon" />
              <span>课程精讲</span>
              <div class="line"></div>
            </div>
            <div class="iconBox">
              <img src="../../assets/image/icon_ranking.png" alt="icon" />
              <span>排位赛</span>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="bg1">
      <div class="title">
        <strong><h3>健身国职考试资讯</h3></strong>
        <span>分享最新最棒的健身资讯，让你实时了解健身行业情况</span>
      </div>
      <div class="row">
        <div class="new">
          <div class="new_box" @click="article">
            <img src="../../assets/image/infoCover1.jpg" class="new_img">
            <div class="new_title">
              <h4>健身教练国职考试-俯卧撑提升技巧</h4>
              <p>2020-07-21</p>
            </div>
          </div>
        </div>
        <div class="new">
          <div class="new_box" @click="otherArticle">
            <img src="../../assets/image/infoCover2.jpg" class="new_img">
            <div class="new_title">
              <h4>健身教练国职考试-徒手下蹲和坐姿体前屈提升技巧</h4>
              <p>2020-07-21</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg2">
      <div class="map_bg">
        <div class="title">
          <h3>用户分布</h3>
          <span>每天都有遍布全国的教练和想当教练的朋友在教练王者学习</span>
        </div>
        <div class="rows">
          <img src="../../assets/image/map3.png" alt="map" />
          <div class="map_info wow fadeInLeft">
            <p>
              用户覆盖全国
              <span>32</span>个省/市/区
            </p>
            <p>
              累计服务教练
              <span>100000+</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <section class="inner_1600" style="background:#fff">
      <div class="code">
        <div class="customized wow fadeInDown">
          <div style="margin-right:40px;">
            <h4>教练王者微信小程序</h4>
            <p>专为健身教练量身定制的一款学习软件</p>
          </div>
          <img src="../../assets/image/phoneappletcode.png" alt="kings" class="imgs" />
        </div>
        <div class="xian"></div>
        <div class="customized wow fadeInUp">
          <div style="margin-right:40px;">
            <h4>教练王者微信公众号</h4>
            <p>更多健身行业资讯</p>
          </div>
          <img src="../../assets/image/account.png" alt="account" class="imgs" />
        </div>
      </div>
    </section>

    <div class="inner_1600">
      <div class="boxs">
        <span>友情链接</span>
        <ul>
          <li>
            <a href="http://www.fitcc.net.cn/" target="_blank">深圳市健行网络有限公司</a>
          </li>
          <li>
            <a href="http://www.sport.gov.cn/" target="_blank">国家体育总局</a>
          </li>
          <li>
            <a href="http://www.sportosta.org.cn/" target="_blank">国家体育总局职业技能鉴定网络管理平台</a>
          </li>
        </ul>
      </div>
    </div>
    <footer>
      <div class="box">
        <div class="fl ship">
          <div>导航索引</div>
          <ul>
            <li>
              <a href="index.html">首页</a>
            </li>
            <li>
              <a href="search.html">搜题</a>
            </li>
            <li>
              <a href="videopage.html">实操视频</a>
            </li>
            <li>
              <a href="download.html">下载APP</a>
            </li>
          </ul>
        </div>
        <div class="fl ship">
          <div>联系我们</div>
          <ul class="fl">
            <li>18138288438</li>
            <li>深圳市健行网络有限公司</li>
          </ul>
        </div>
        <div class="fr" style="position: relative">
          <a href="javascript:void(0);" class="other">
            <img src="../../assets/image/wx.png" alt="wx" style="margin-right:40px" />
            <img src="../../assets/image/account.png" alt="account" class="hove" />
          </a>
          <a href="https://weibo.com/u/7298273841" target="_blank">
            <img src="../../assets/image/wb.png" alt="wb" />
          </a>
        </div>
        <div class="clearfix"></div>
      </div>
      <p class="Copyright">Copyright ©2018-2020 All rights reserved. 深圳市健行网络有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18035165号-1</a></p>
    </footer>

    <div class="scrollTop">
      <ul>
        <li>
          <div class="follow">
            <p>扫码关注</p>
            <img src="../../assets/image/kings.png" alt="img" class="ma" />
          </div>
        </li>
        <li @click="onWx">
          <img src="../../assets/image/weixin.png" alt="img" />
          <span>官方微信</span>
        </li>
        <li @click="onWb">
          <img src="../../assets/image/weibo.png" alt="img" />
          <span>关注微博</span>
        </li>
        <li @click="scrollToTop">
          <img src="../../assets/image/top.png" alt="img" />
          <span>返回顶部</span>
        </li>
      </ul>
    </div>

    <img src="../../assets/image/wechatcode.jpg" alt="img" v-if="wx" class="wCode" />
    <div class="shade" v-if="wx" @click="onWx"></div>

    <img src="../../assets/image/weibocode.jpg" alt="img" v-if="wb" class="wCode" />
    <div class="shade" v-if="wb" @click="onWb"></div>
  </section>
</template>


<script>
import $ from "jquery";
import { WOW } from "wowjs";
import { visits } from "@/utils/visits";
import "../../assets/js/jquery.singlePageNav.min.js";
export default {
  data() {
    return {
      index: 0,
      scrollTopNav: true,
      wx: false,
      wb: false,
      titleKeyWords:"",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  created() {
    $(function() {
      $(".nav").singlePageNav({
        offset: 50
      });
      new WOW().init();
    });

    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      window.location.href = "mobile.html";
    } else {
      return;
    }
  },
  methods: {
    scrollToTop() {
      $("body,html").animate({ scrollTop: 0 }, 300);
    },
    // 搜索
    onQuery(){
      if(this.titleKeyWords!==''){
        window.location.href = `search_list.html?words=${this.titleKeyWords}`
      }else{
        alert('请正确搜索内容')
      }
    },
    otherArticle() {
      window.open(`otherArticle.html`)
    },
    article() {
      window.open(`article.html`)
    },
    handleScroll(e) {
      let scrollTop = e.target.documentElement.scrollTop;
      if (scrollTop > 100) {
        this.scrollTopNav = false;
      } else {
        this.scrollTopNav = true;
      }
    },
    onWb() {
      if (this.wb) {
        this.wb = false;
      } else {
        this.wb = true;
      }
    },
    onWx() {
      if (this.wx) {
        this.wx = false;
      } else {
        this.wx = true;
      }
    }
  }
};
</script>

<style>

/* 基本样式 */
.Copyright{
  color: #4f5460;
}

.Copyright a{
  color: #4f5460;
}

.banner {
  position: absolute;
  left: 50%;
  top: 240px;
  transform: translate(-50%, 0);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner h2 {
  font-size: 48px;
  font-weight: bold;
}

.banner span {
  font-size: 20px;
  margin-top: 24px;
}

.button {
  margin-top: 40px;
  width: 200px;
  height: 60px;
  line-height: 60px;
  border-radius: 4px;
  display: block;
  background: none;
  text-align: center;
  position: relative;
  z-index: 1;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
}
.button:focus {
  outline: none;
}
.button > span {
  vertical-align: middle;
}

.button--nina {
  background: #54e5b4;
  color: #fff;
  overflow: hidden;
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.button--nina.button--inverted {
  background: #fff;
  color: #54e5b4;
}
.button--nina > span {
  opacity: 0;
  color: #fff;
  -webkit-transform: translate3d(0, -10px, 0);
  transform: translate3d(0, -10px, 0);
  -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
  transition: transform 0.3s, opacity 0.3s;
  -webkit-transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
}

.button--nina::before {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 20px;
  -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
  transition: transform 0.3s, opacity 0.3s;
  -webkit-transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
}

.button--nina:hover {
  background-color: #29cc95;
}

.button--nina:hover::before {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

.button--nina:hover > span {
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.button--nina:hover > span:nth-child(1) {
  -webkit-transition-delay: 0.045s;
  transition-delay: 0.045s;
}

.button--nina:hover > span:nth-child(2) {
  -webkit-transition-delay: 0.09s;
  transition-delay: 0.09s;
}
.button--nina:hover > span:nth-child(3) {
  -webkit-transition-delay: 0.135s;
  transition-delay: 0.135s;
}

.button--nina:hover > span:nth-child(4) {
  -webkit-transition-delay: 0.18s;
  transition-delay: 0.18s;
}

.wheel {
  background: url(../../assets/image/banner_bg.png) no-repeat;
  min-width: 1600px;
  height: 1080px;
  position: relative;
  overflow: hidden;
}

.bgs {
  width: 100%;
  height: 1080px;
  background: rgba(52, 55, 64, 0.6);
}

.banner_pohone {
  position: absolute;
  bottom: -150px;
  left: 50%;
  transform: translate(-50%, 0);
}

.rights {
  transform: translate(20%, 0);
  bottom: -200px;
}

.lefts {
  transform: translate(-125%, 0);
  bottom: -200px;
}

.search {
  width: 350px;
  height: 40px;
  border: 1px solid #fff;
  border-right: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  float: right;
}

.search input {
  width: 280px;
  background: none;
  color: #fff;
}

input::-webkit-input-placeholder {
  color: #fff;
}

.ques {
  width: 40px;
  height: 40px;
  background: #54e5b4;
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.introduce {
  padding: 80px 0;
  margin: 0 auto;
  position: relative;
  width: 1200px;
}

.bg1 {
  background: #fff;
  padding: 80px 0;
  position: relative;
  min-width: 1600px;
}

.bg2 {
  background: url(../../assets/image/map1.png) no-repeat;
  position: relative;
  min-width: 1600px;
}

.detailed {
  background: url(../../assets/image/map2.png) no-repeat;
  min-width: 1200px;
  height: 480px;
  position: relative;
  margin-top: 53px;
}

.keyboard {
  width: 1200px;
  height: 480px;
  background: rgba(52, 55, 64, 0.95);
  padding: 68px 0 57px 0;
  display: flex;
  align-content: space-between;
  justify-content: space-between;
  flex-wrap: wrap;
}

.iconBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  width: 220px;
  color: #fff;
}

.iconBox span {
  margin: 24px 0 10px 0;
}

.line {
  width: 20px;
  height: 2px;
  background: #54e5b4;
}

.title {
  display: flex;
  flex-direction: column;
}

.title h3 {
  z-index: 1;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
}

.title span {
  font-size: 18px;
  color: rgba(52, 55, 64, 0.6);
  text-align: center;
  margin-top: 8px;
}

.row {
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 50px auto 0 auto;
}

.new_img {
  width: 150px;
  height: 100px;
  background: #f5f5f5;
  margin-right: 24px;
}

.new_box {
  font-size: 14px;
  color: #707070;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 40px;
}

.new_box:hover h4 {
  color: #54e5b4;
}

.new_title h4 {
  font-size: 16px;
  font-weight: bold;
  width: 350px;
  margin-bottom: 15px;
}

.rows {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 70px auto auto auto;
  width: 1200px;
}

.map_bg {
  padding: 80px 0;
  background: rgba(52, 55, 64, 0.95);
  color: #fff;
}

.map_bg span {
  color: rgba(255, 255, 255, 0.6);
}

.map_info {
  min-width: 360px;
  margin-left: 150px;
}

.map_info p {
  font-size: 24px;
  height: 100px;
}

.map_info span {
  font-size: 48px;
  color: #54e5b4;
}

.code {
  height: 360px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.customized {
  display: flex;
  align-items: center;
  font-size: 24px;
}

.customized p {
  font-size: 14px;
  margin-top: 16px;
}

.customized .imgs {
  width: 200px;
  height: 200px;
}

.xian {
  height: 120px;
  border: 0.5px solid #707070;
}

.boxs {
  width: 1200px;
  height: 136px;
  background: #f5f5f5;
  padding: 40px 0;
  text-align: center;
  color: #343740;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: start;
}

.boxs span {
  color: #343740;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.boxs ul li a {
  color: #343740;
}

.boxs ul li a:hover {
  color: #54e5b4;
}

.boxs ul li::after {
  content: "|";
  margin: 0 15px;
}

.boxs ul li:last-child:after {
  content: "";
}

.boxs ul {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>




// WEBPACK FOOTER //
// src/pages/index/index.vue